// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".primary-green[data-v-c278d3f4]{background-color:#739f38 !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
